define('charts/dataseries',["require", "exports", "../geo/trig", "../util/convert", "../util/pubsub"], function (require, exports, trig_1, convert_1, pubsub_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.seriesUpdates = exports.all = exports.timeSeries = exports.altitude = exports.Axis = void 0;
    var Axis;
    (function (Axis) {
        Axis[Axis["Time"] = -1] = "Time";
        Axis[Axis["Distance"] = 0] = "Distance";
        Axis[Axis["Speed"] = 1] = "Speed";
        Axis[Axis["Glide"] = 2] = "Glide";
        Axis[Axis["Degrees"] = 3] = "Degrees";
    })(Axis = exports.Axis || (exports.Axis = {}));
    var time = {
        axis: Axis.Time,
        color: "black",
        enabled: false,
        hotkey: "",
        name: "Time",
        statElementId: "flight-stats-time",
        localValue: function (d, track) {
            return (d.millis - track.startTime()) / 1000;
        },
        localString: function (d, track) {
            var delta = (d.millis - track.startTime()) / 1000;
            return isNaN(delta) ? "" : delta.toFixed(1) + " s";
        }
    };
    exports.altitude = {
        axis: Axis.Distance,
        color: "black",
        enabled: true,
        hotkey: "e",
        name: "Elevation",
        statElementId: "flight-stats-alt",
        localValue: function (d) { return convert_1.default.distance.localValue(d.alt); },
        localString: function (d) { return convert_1.default.distance.localString(d.alt); }
    };
    var horizontal = {
        axis: Axis.Speed,
        color: "#d11",
        enabled: true,
        hotkey: "h",
        name: "Horizontal",
        statElementId: "flight-stats-vx",
        localValue: function (d) { return convert_1.default.speed.localValue(d.groundspeed); },
        localString: function (d) { return convert_1.default.speed.localString(d.groundspeed); }
    };
    var vertical = {
        axis: Axis.Speed,
        color: "#191",
        enabled: true,
        hotkey: "v",
        name: "Vertical",
        statElementId: "flight-stats-vy",
        localValue: function (d) { return convert_1.default.speed.localValue(-d.climb); },
        localString: function (d) {
            if (d.climb < 0) {
                return convert_1.default.speed.localString(-d.climb);
            }
            else if (d.climb >= 0) {
                return "+" + convert_1.default.speed.localString(d.climb);
            }
            else {
                return "";
            }
        }
    };
    var speed = {
        axis: Axis.Speed,
        color: "#11d",
        enabled: true,
        hotkey: "s",
        name: "Speed",
        statElementId: "flight-stats-v",
        localValue: function (d) { return convert_1.default.speed.localValue(Math.sqrt(d.vN * d.vN + d.vE * d.vE + d.climb * d.climb)); },
        localString: function (d) { return convert_1.default.speed.localString(Math.sqrt(d.vN * d.vN + d.vE * d.vE + d.climb * d.climb)); }
    };
    var sustainedX = {
        axis: Axis.Speed,
        color: "#d11",
        enabled: true,
        hotkey: "x",
        name: "Sustained X",
        statElementId: "flight-stats-sustained-x",
        localValue: function (d) { return convert_1.default.speed.localValue(d.sustained_x); },
        localString: function (d) { return convert_1.default.speed.localString(d.sustained_x); }
    };
    var sustainedY = {
        axis: Axis.Speed,
        color: "#191",
        enabled: true,
        hotkey: "y",
        name: "Sustained Y",
        statElementId: "flight-stats-sustained-y",
        localValue: function (d) { return convert_1.default.speed.localValue(d.sustained_y); },
        localString: function (d) { return convert_1.default.speed.localString(d.sustained_y); }
    };
    var glideRatio = {
        axis: Axis.Glide,
        color: "#109bb4",
        enabled: true,
        hotkey: "g",
        name: "Glide ratio",
        statElementId: "flight-stats-glide",
        localValue: function (d) { return d.glideRatio; },
        localString: function (d) { return convert_1.default.glide.localString(d.glideRatio, 2); }
    };
    // const diveAngle = {
    //   axis: Axis.Degrees,
    //   color: "#5000be",
    //   enabled: true,
    //   hotkey: "a",
    //   name: "dive Angle",
    //   statElementId: "flight-stats-dive-angle",
    //   localValue(d: Point) { return Math.atan2(d.groundspeed, d.climb) } // TODO
    // }
    var ld = {
        axis: Axis.Glide,
        color: "#6f00ff",
        enabled: true,
        hotkey: "l",
        name: "Ld",
        statElementId: "flight-stats-l-d",
        localValue: function (d) { return d.sustained_x / d.sustained_y; },
        localString: function (d) { return convert_1.default.glide.localString(d.sustained_x / d.sustained_y, 2); }
    };
    // const bearing = {
    //   axis: Axis.Degrees,
    //   color: "#6f00ff",
    //   enabled: true,
    //   hotkey: "b",
    //   name: "Bearing",
    //   statElementId: "flight-stats-bearing",
    //   localValue(d: Point) { return Math.atan2(d.vE, d.vN) },
    //   localString(d: Point) { return toFixedDegrees(Math.atan2(d.vE, d.vN)) + "°" }
    // }
    var roll = {
        axis: Axis.Degrees,
        color: "#ee1",
        enabled: false,
        hotkey: "r",
        name: "Roll",
        statElementId: "flight-stats-roll",
        localValue: function (d) { return (0, trig_1.toDegrees)(d.roll); },
        localString: function (d) { return toFixedDegrees(d.roll); }
    };
    function toFixedDegrees(radians) {
        return radians === undefined ? "" : (0, trig_1.toDegrees)(radians).toFixed(0) + "°";
    }
    exports.timeSeries = [exports.altitude, horizontal, vertical, speed, glideRatio];
    exports.all = [
        time, exports.altitude, horizontal, vertical, speed, glideRatio, sustainedX, sustainedY, ld, roll
    ];
    /**
     * Notify when use toggles a data series on or off.
     */
    exports.seriesUpdates = new pubsub_1.PubSub();
});
//# sourceMappingURL=/assets/javascripts/charts/dataseries.js.map;
